module.exports = __webpack_public_path__ + "static/banner02lemons-3d4dc6ac766401c230261a0b6ab54089.jpg";